import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'

const CONNECTED_STATES = ["Connected", "ScheduledDown"]
const DISCONNECTED_STATES = ["Unknown", "Disconnected", "UnableToConnect"]
const INIT_STATES = ["Initializing", "Connecting"]

const HealthStatusServiceMDSStreamManager = ({ data, env }) => {
    const tab_col = [
        {
            field: "host_name",
            headerName: "Host",
            minWidth: 150,
            sort: "asc",
            suppressSizeToFit: true,
        },
        {
            field: "dr",
            headerName: "DR",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "total",
            headerName: "Total",
            minWidth: 150,
            hide: true,
            suppressSizeToFit: true,
        },
        {
            field: "pid",
            headerName: "Process Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "price_server_id",
            headerName: "Price Server Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "stream_id",
            headerName: "MDS Stream Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "connection_id",
            headerName: "Connection Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "connection_status",
            headerName: "Status",
            minWidth: 150,
            suppressSizeToFit: true,
        },
    ]

    const tab_col2 = [
        {
            field: "connection_id",
            headerName: "Connection Id",
            minWidth: 150,
            sort: "asc",
            suppressSizeToFit: true,
        },
        {
            field: "stream_id",
            headerName: "MDS Stream Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "username",
            headerName: "User Name",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "connection_type",
            headerName: "Connection Type",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "connection_type_id",
            headerName: "Connection Type Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "primary_ip",
            headerName: "Primary IP",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "primary_port",
            headerName: "Primary Port",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "secondary_ip",
            headerName: "Secondary IP",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "secondary_port",
            headerName: "Secondary Port",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "target_comp_id",
            headerName: "Target Comp Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "sender_comp_id",
            headerName: "Sender Comp Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
    ]

    const psRowStyle = (params) => {
        if (params.data.connection_status === 'Open') {
            return { color: 'black', backgroundColor: '#FFFFFF' }
        } else if (CONNECTED_STATES.includes(params.data.connection_status)) {
            return { color: 'white', backgroundColor: '#00873D' }
        } else if (DISCONNECTED_STATES.includes(params.data.connection_status)) {
            return { color: 'white', backgroundColor: '#B4130B' }
        } else if (INIT_STATES.includes(params.data.connection_status)) {
            return { color: 'black', backgroundColor: '#FDFB98' }
        }
    };

    const [tab_data, settab_data] = useState([])
    const [connectedSessions, setConnectedSessions] = useState([])
    const [disconnectedSessions, setDisconnectedSessions] = useState([])
    const [initializingSessions, setInitializingSessions] = useState([])

    useEffect(() => {
        let tab_data_temp = []
        let connectedSess = []
        let disconnectedSess = []
        let initSess = []

        if (data.price_stream_nodes) {
            tab_data_temp = data.price_stream_nodes.reduce((rowData, row) => {
                rowData.push({
                    uniqueId: row.pid,
                    host_name: row.host_name,
                    total: row.expected_price_servers_on_host,
                    dr: row.is_dr_price_server ? "DR" : "Primary",
                    connection_id: row.connection_id,
                    connection_status: row.connection_status ? row.connection_status : "Open",
                    stream_id: row.stream_id,
                    price_server_id: row.price_server_id,
                    pid: row.pid
                })
                return rowData
            }, [])

            connectedSess = data.price_stream_nodes.reduce((rowData, row) => {
                if (CONNECTED_STATES.includes(row.connection_status)) {
                    rowData.push(row.connection_id)
                }
                return rowData
            }, [])
            disconnectedSess = data.price_stream_nodes.reduce((rowData, row) => {
                if (DISCONNECTED_STATES.includes(row.connection_status)) {
                    rowData.push(row.connection_id)
                }
                return rowData
            }, [])
            initSess = data.price_stream_nodes.reduce((rowData, row) => {
                if (INIT_STATES.includes(row.connection_status)) {
                    rowData.push(row.connection_id)
                }
                return rowData
            }, [])

        }

        settab_data(tab_data_temp)
        setConnectedSessions(connectedSess)
        setDisconnectedSessions(disconnectedSess)
        setInitializingSessions(initSess)

    }, [data.price_stream_nodes])

    const [tab_data2, settab_data2] = useState([])
    const connRowStyle = (params) => {
        if (connectedSessions.includes(params.data.connection_id)) {
            return { color: 'white', backgroundColor: '#00873D' }
        } else if (disconnectedSessions.includes(params.data.connection_id)) {
            return { color: 'white', backgroundColor: '#B4130B' }
        } else if (initializingSessions.includes(params.data.connection_id)) {
            return { color: 'black', backgroundColor: '#FDFB98' }
        }
        else {
            return { color: 'black', backgroundColor: '#FFFFFF' }
        }
    };


    useEffect(() => {
        let tab_data_temp2 = []
        if (data.price_stream_connections) {
            tab_data_temp2 = data.price_stream_connections.reduce((rowData, row) => {
                rowData.push({
                    uniqueId: row.connection_id,
                    connection_id: row.connection_id,
                    stream_id: row.stream_id,
                    username: row.username,
                    connection_type: row.connection_type,
                    connection_type_id: row.connection_type_id,
                    primary_ip: row.primary_ip,
                    primary_port: row.primary_port,
                    secondary_ip: row.secondary_ip,
                    secondary_port: row.secondary_port,
                    target_comp_id: row.target_comp_id,
                    sender_comp_id: row.sender_comp_id
                })
                return rowData
            }, [])
        }
        settab_data2(tab_data_temp2)
    }, [data.price_stream_connections])


    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            {tab_data.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Price Servers</Text>
                    <AgDataTable
                        tab_col={tab_col}
                        tab_data={tab_data}
                        tableName="HealthStatusServiceMDSStreamManagerPriceStreams"
                        tableHeight={700}
                        getRowStyle={psRowStyle}
                    />
                </>
            }

            {tab_data2.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }}
                        size="small" color="dark-3" weight="bold">Price Connections</Text>
                    <AgDataTable
                        tab_col={tab_col2}
                        tab_data={tab_data2}
                        tableName="HealthStatusServiceMDSStreamManagerPriceConnections"
                        tableHeight={700}
                        getRowStyle={connRowStyle}
                    />
                </>
            }
        </Box>
    )
}

export default HealthStatusServiceMDSStreamManager